/**
 * soft 스킨 — 파스텔·부드러움.
 *
 * 감성 키워드:
 * - 둥근 모서리 + 넉넉한 여백
 * - 얕은 그림자 + 테두리 최소화
 * - 중립적 파스텔 배경(overlay 에서 지정)
 *
 * CSS overlay 위치: styles/skins.css — `body[data-skin="soft"]` 블록
 */
import type { SkinDef } from './types'

export const softSkin: SkinDef = {
  key: 'soft',
  label: '소프트',
  description: '부드러운 그림자와 둥근 모서리',
  swatch: { bg: '#faf7f2', fg: '#2a2a2a', accent: '#a7c7e7' },
  token: {
    borderRadius: 14,
    borderRadiusLG: 18,
    borderRadiusSM: 10,
    wireframe: false
  },
  componentDefaults: {
    Card: {
      borderRadiusLG: 18
    },
    Button: {
      borderRadius: 14
    },
    Input: {
      borderRadius: 12
    }
  }
}
